.root {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  // Don't stretch to fill the cell — let the trigger size to its content
  // so the rounded right edge stays comfortably inside the cell padding.
  max-width: 100%;
  min-width: 0;
}

.dot {
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  height: 8px;
  width: 8px;
}

.dot-priority-high {
  background: #dc2626;
}

.dot-priority-medium {
  background: #d97706;
}

.dot-priority-low {
  background: #047857;
}

/* --- Trigger button --- */

.trigger {
  align-items: center;
  background: var(--color-background, #ffffff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  height: 32px;
  outline: none;
  padding: 0 12px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.trigger:hover:not(:disabled) {
  border-color: var(--color-foreground);
}

.trigger:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.trigger-is-open {
  border-color: var(--color-focus);
  box-shadow: 0 0 0 2px var(--color-focus);
}

.trigger-priority-high {
  color: #b91c1c;
}

.trigger-priority-medium {
  color: #b45309;
}

.trigger-priority-low {
  color: #047857;
}

.triggerLabel {
  text-align: left;
  white-space: nowrap;
}

.chevron {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  margin-left: 4px;
  width: 14px;
}

/* --- Portal-rendered menu --- */

.menu {
  background: var(--color-background, #ffffff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  padding: 6px 8px;
  position: fixed;
  z-index: 100;
}

.option,
.option-is-selected {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--color-foreground);
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 14px;
  gap: 8px;
  padding: 8px 16px 8px 12px;
  text-align: left;
  transition: background-color 0.1s;
  width: 100%;
}

.option:hover,
.option-is-selected:hover {
  background: var(--color-surface, #f9fafb);
}

.option-is-selected {
  font-weight: 600;
}

.optionLabel {
  flex: 1;
}
